/**
 * Initial state for the zoom module.
 *
 * @module store/modules/zoom/state
 */
import { ZoomState } from "./types";

const state: ZoomState = {
  meetings: {},
};

export default state;
